<template>
  <AtomsContainersCornerBorders :size="1" class="p-6 mt-4 text-lg tracking-normal text-center bg-neutral-100">
    <strong>{{ $t('Líbí se vám produkt?') }}</strong>
    <div class="my-4">{{ $t('Kupte si') }} <strong>{{ props.wareName }}</strong> {{ props.priceText }} <strong>{{ props.priceFormatted }}</strong></div>
    <MoleculesButtonsButton class="text-base" @click="click">{{ props.buttonText }}</MoleculesButtonsButton>
  </AtomsContainersCornerBorders>
</template>
<script setup>

const props = defineProps({
  wareName: String,
  priceText: String,
  priceFormatted: String,
  buttonText: String
});

const emit = defineEmits(['click']);

const click = () => emit('click');

</script>